<template>
  <div class="content">
    <div class="cont-list">
      <span class="list">{{
        this.parentRoute.menuName + "-" + this.route.menuName
      }}</span>
      <span class="masge">当前共有{{ total }}条流程</span>
    </div>
    <div class="header">
      <div class="left">
        <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增卡片</el-button>
        <!-- <el-button class="btn" size="small" :disabled="multiple" v-preventReClick
            @click="handleDelete">批量删除</el-button> -->
      </div>
      <div class="right">
        <div class="search">
          <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
            <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
          </el-input>

        </div>
        <span v-preventReClick @click="reset">重置</span>
      </div>
    </div>

    <el-tabs v-if="apps.length > 1" v-model="query.appId" @tab-click="tabClick" stretch>
      <el-tab-pane v-for="item in apps" :key="item.id" :name="item.id + ''">
        <template slot="label">
          <span style="margin: 0 10px"> {{ item.name }} </span>
        </template>
      </el-tab-pane>
    </el-tabs>

    <el-empty v-if="!tableData || tableData.length == 0" description="暂无流程卡片"></el-empty>
    <template v-for="item in tableData">
      <div :key="item.id" class="wf-card" v-preventReClick @click="showList(item)">
        <div class="wf-card-title">
          <span class="wf-card-title">{{ item.name }}</span>
          <!-- <el-checkbox v-model="item.checked" class="wf-card-title" @change="handleSelectionChange">{{item.name}}</el-checkbox> -->
          <i class="el-icon-arrow-right wf-card-arrow-right"></i>
          <i class="el-icon-edit-outline wf-card-arrow-right pointer" v-preventReClick @click="handleUpdate(item, $event)" />
        </div>

        <el-form label-width="73px" label-position="left">
          <el-form-item label="表单名称:">
            <span class="value">{{ item.moduleName }}</span>
          </el-form-item>
          <el-form-item label="当前启用:">
            <span class="value">{{ item.tempName }}</span>
          </el-form-item>
          <el-form-item label="创建时间:">
            <span class="value">{{
              parseTime(new Date(item.createdTime))
            }}</span>
          </el-form-item>
          <el-form-item label="流程备注:">
            <span class="value">{{ item.desc }}</span>
          </el-form-item>
        </el-form>
      </div>
    </template>

    <el-dialog :title="title + '流程卡片'" :visible.sync="open" :center="true" width="500px" :before-close="cancel" :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入名称"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top:10px">
          <el-col :span="24">
            <el-form-item label="表单名称" prop="moduleName">
              <el-select :disabled="Boolean(form.id)" v-model="form.moduleName" placeholder="请选择表单名称" filterable :filter-method="getModules" @change="moduleChange" style="width:100%">
                <el-option v-for="item in moduleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="margin-top:10px">
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.desc" placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { SaveWorkFlowCard, GetWorkFlowCards, GetModules } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
// import Info from './info';

export default {
  mixins: [GetDataMixin],
  components: {
    // Info
  },
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 100,
        pageIndex: 1,
        // appId: '2',
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出框标题
      // 弹出编辑框
      open: false,
      id: 0,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      cancelButtonText: "禁用",
      rules: {
        moduleName: [
          { required: true, message: "表单名称不能为空", trigger: "blur" },
        ],
        name: [{ required: true, message: "名称不能为空", trigger: "blur" }],
      },
      moduleList: [],
      modelIds: [],
      isMedicine:false
    };
  },
  props: {
    // appId: {
    //   type: Number,
    //   default () {
    //     return 2;
    //   },
    // },
  },
  computed: {
    apps () {
      let apps = this.$store.state.user.apps;
      return apps
      // let thisApps = apps.filter(e => e.id != 1)
      // // this.query.appId = thisApps[0].id + ''
      // // this.getData()
      // return thisApps
    },
  },
  created () {
    var query = this.$route.query;
    if (query.appId) {
      this.query.appId = query.appId;
    }
  },

  methods: {
    handleSelectionChange () {
      this.multipleSelection = this.tableData.filter((e) => e.checked);
      this.ids = this.multipleSelection.map((item) => item.id);
      this.multiple = !this.multipleSelection.length;
    },
    // 获取列表
    getData () {
      GetWorkFlowCards(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
        this.modelIds = res.returnData.data.map((item) => item.moduleId);
        // this.getModules("");
      });
    },
    // 查看信息
    handleInfo (row) {
      this.id = row.id;
    },
    closeInfo () {
      this.id = 0;
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.resetForm();
      // this.$router.push("/user-edit");
      this.getModules('')
    },
    // 编辑
    handleUpdate (row, e) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      // this.form.state = Boolean(this.form.state);
      this.open = true;
      // this.$router.push("/user-edit?id=" + row.id);
      this.getModules('')

      e.stopPropagation();
    },
    showList (item) {
      this.$router.push(
        `/workflow-list?id=${item.id}&name=${item.name}&moduleId=${item.moduleId}&appId=${this.query.appId}&isMedicine=${this.isMedicine}`
      );
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        this.form.state = Number(this.form.state);
        SaveWorkFlowCard(this.form)
          .then((res) => {
            // if (res.successful == false) {
            //   this.$my_message(res.errorMessage,"error")
            //   return;
            // }
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally((res) => {
            this.form.state = Boolean(this.form.state);
          });
      });
    },
    resetForm () {
      this.form = {
        name: "",
        moduleName: "",
        state: true,
        appId: this.query.appId,
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑部门
    cancel () {
      this.open = false;
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },

    // 删除
    handleDelete (row) {
      const ids = row && row.id ? [row.id] : this.ids;

      this.$my_confirm("此操作将删除数据, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          return UpdateUserStatesById({ ids, state });
        })
        .then(() => {
          this.$my_message(`操作成功！`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query = {
        keyWord: "",
        pageSize: 100,
        pageIndex: 1,
        appId: this.appId,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },

    moduleChange (val) {
      this.form.moduleId = val;
    },

    getModules (keyWord) {
      GetModules({
        pageSize: 100,
        pageIndex: 1,
        keyWord: keyWord,
        appId: this.query.appId,
        type: 3,
        ids: this.modelIds,
      }).then((res) => {
        this.moduleList = res.returnData.data;
      });
    },

    tabClick (tab,event) {
      if(tab.name==4){
        this.isMedicine = true
      }else{
        this.isMedicine = false
      }
      
      this.getData();
    },
  },
  mounted () {

    // 第一次点进来的时候query是空，要赋值
    // 返回上一级 由created 里面获取赋值了
    if (this.query.appId == null || this.query.appId == 0) {
      this.query.appId = this.apps[0].id + ''
    }
    this.getData()
  },
};
</script>

<style lang="scss" scoped>
.wf-card {
  width: calc(33% - 76px); // 412px;
  height: 146px;
  background: #f5f6fa;
  margin: 0 40px 40px 0;
  float: left;
  border-top: 6px rgba(40, 106, 180, 0.5) solid;
  padding: 20px;
}
.wf-card:hover {
  border-top: 6px rgb(40, 106, 180) solid;
  box-shadow: 0px 3px 6px #abafbf;
}
.wf-card-title {
  font-size: 16px;
  font-weight: bold;
  color: #303033;
  height: 16px;
  margin-bottom: 20px;
}
.wf-card-arrow-right {
  float: right;
  height: 20px;
  width: 20px;
  font-weight: bold;
}

/deep/ .el-form-item__content {
  line-height: 20px !important;
  color: #666666;
  font-weight: 400;
}
/deep/ .el-form-item__label {
  padding-bottom: 0 !important;
  line-height: 20px !important;
}
.el-form-item {
  margin-bottom: 7px !important;
}
.value {
  color: #666666;
}

.el-tabs {
  width: 360px;
  margin-bottom: 10px;
}
</style>
